
    import '/home/ec2-user/Youlify-Design/components/calendar/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["calendar-demo-basic","calendar-demo-notice-calendar","calendar-demo-card","calendar-demo-select","calendar-demo-lunar","calendar-demo-week","calendar-demo-customize-header","calendar-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/calendar/index.en-US.md?type=demo')
};